<div class="main">
  <div *ngIf="showLoader" class="loader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
    <div class="header">
      <span *ngIf="!editUnit">{{'ENTITYDETAILS.addUnit' | translate}}</span>
      <span *ngIf="editUnit">{{'ENTITYDETAILS.editUnit' | translate}}</span>
      <i class="material-icons" (click)='closeDialog("");'>clear</i>
    </div>
    <div class="section">
        <div class="addBody">
          <div class="bodyLeft">
            <div class="form">
              <div class="form-label"><sup style="color: #E54131; font-weight: 900;">*</sup>{{'ENTITYDETAILS.name' | translate}}</div>
              <input class="form-input" [(ngModel)]="newEntityData.name" type="text" />
            </div>
            <div class="form">
              <div class="form-label"><sup style="color: #E54131; font-weight: 900;">*</sup>{{'ENTITYDETAILS.address' | translate}}</div>
              <input  class="form-input" [(ngModel)]="newEntityData.location.area" type="text" id='addressSearch' autocomplete='false'/>
            </div>
            <div class="form">
              <div class="form-label">{{'ENTITYDETAILS.locality' | translate}}</div>
              <input  class="form-input" [(ngModel)]="newEntityData.location.locality" type="text" id='addressSearch' autocomplete='false'/>
            </div>
            <div class="form">
              <div class="form-label"><sup style="color: #E54131; font-weight: 900;">*</sup>{{'ENTITYDETAILS.city' | translate}}</div>
              <input class="form-input" [(ngModel)]="newEntityData.location.city" type="text" autocomplete='false'/>
            </div>
          </div>
          <div class="bodyCenter">
            <div class="form" *ngIf="!editUnit">
              <div class="form-label"><sup style="color: #E54131; font-weight: 900;">*</sup>{{'ENTITYDETAILS.country_code' | translate}}</div>
              <mat-select class='form-input'  [(ngModel)]="selectedCountry" style="width: 96%;">
              <mat-option *ngFor="let country of countries" (onSelectionChange)="selectCountry(country)" [value]="country">
                {{country.name}}
              </mat-option>
              </mat-select>
            </div>
            <div class="form">
              <div class="form-label" style="margin-top: 2px;">{{'ENTITYDETAILS.pincode' | translate}}</div>
              <input class="form-input" [(ngModel)]="newEntityData.location.pincode" type="text" autocomplete='false' />
            </div>
            <div class="form">
              <div class="form-label">{{'ENTITYDETAILS.contact_person' | translate}}</div>
              <input class="form-input" [(ngModel)]="newEntityData.location.contact_name" type="text" autocomplete='false'/>
            </div>
            <div class="form">
              <div class="form-label" style="margin-top: 3px;">{{'ENTITYDETAILS.mobile' | translate}}</div>
              <input class="form-input" [(ngModel)]="newEntityData.location.mobile" type="text" autocomplete='false'/>
            </div>
          </div>
          <div class="bodyRight">
            <div class="form">
              <div class="form-input form-button" (click)="openFeaturesModal();">
                {{'ENTITYDETAILS.featuresSubFeatures' | translate}}
              </div>
            </div>
            <app-features class="features" *ngIf="showFeatures" (featuresToSend) = "getFeaturesFromChild($event)" [featuresArray] = "dataToSend"></app-features>
          </div>
        </div>
        <div class="submitButton" (click)="submit()">
          <div style="width:90%"></div>
          <div class="button">
              {{'ENTITYDETAILS.submit' | translate}}
          </div>
        </div>
    </div>
  </div>
  